import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type { StoreState } from '../../state-types';

/** Get Core Question by core question `id` */
export const getCoreQuestion =
    (coreQuestionId: string) =>
    (state: StoreState): CoreQuestionResource | undefined =>
        state.coreQuestions[coreQuestionId];
